<template>
    <section>

        <div class="container">
            <div class="tools">
                <button type="button" id="tooltip-gear" class="btn btn-outline-danger" v-if="isEditor" @click="editProblemInThisWindow(publicID)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-gear" viewBox="0 0 16 16">
                        <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/>
                        <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"/>
                    </svg>
                <b-tooltip target="tooltip-gear" variant="info">Modifier dans la base de problèmes</b-tooltip>
                </button>
                <button type="button" id="tooltip-reset" class="btn btn-outline-danger" v-if="isModified" v-on:click="reset">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>
                    </svg>
                    <b-tooltip target="tooltip-reset" variant="info">Revenir à l'énoncé original</b-tooltip>
                </button>
                <button type="button" id="tooltip-edit" class="btn btn-outline-success" v-on:click="showEdit=!showEdit" v-if="cookieAccepted">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                    </svg>
                    <b-tooltip ref="tooltipEdit" target="tooltip-edit" variant="info">Modifer l'énoncé sur cet ordinateur</b-tooltip>
                </button>
                <button type="button" id="tooltip-copy" class="btn btn-outline-success" @click="copy" :disabled="showEdit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-clipboard-check" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                    </svg>
                </button>
                <button type="button" id="tooltip-rod" class="btn btn-outline-success" @click="showTools=!showTools">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-bar-chart-fill" viewBox="0 0 16 16">
                        <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"/>
                    </svg>
                </button>

                <b-tooltip ref="tooltipCopy" target="tooltip-copy" variant="info">Copier le texte de l'énoncé dans le presse-papier</b-tooltip>
                <b-tooltip ref="tooltipTools" target="tooltip-rod" variant="info">Outil réglettes</b-tooltip>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="text-center">

                    <div class="card-text" v-if="!showEdit">
                        <pre>{{ pbText }}</pre>
                    </div>

                    <div class="card-text" v-show="showEdit">
                        <form name="editForm">
                            <textarea ref="edit" class="edit" type="text" v-model="pbText" onfocus="let value = this.value; this.value = null; this.value = value"></textarea>
                        </form>
                    </div>

                    <div v-show="withPIC">
                        <img :src="picURL"/>
                    </div>

                </div>
            </div>
            <div class="col" v-show="showTools" >
                <iframe width="150%" src="https://arnaud-lierville.github.io/responsive-rod.html" frameborder="0"></iframe>
            </div>
        </div>
        
        <textarea ref="copyText" class="copyText" v-model="pbText" rows="1" cols="1"></textarea>
        <b-modal id="done" hide-footer hide-header>
            <div class="text-center">
                <h3 class="text-success">Copié !</h3>
            </div>
        </b-modal>

        <footer>
            <cookie-law theme="base" 
            buttonText="Je suis d'accord !" 
            v-on:accept="thankYouMethod()" 
            :buttonDecline='true'
            buttonDeclineText="Je refuse"
            buttonDeclineClass="btn btn-danger"
            buttonClass="btn btn-success"
            storageName="pel:accepted">
                <div slot="message">
                    Les énoncés modifiés sont stockés dans un coockie.
                </div>
            </cookie-law>
        </footer>
        
    </section>
  
</template>

<script>
// @ is an alias to /src
import { onAuthStateChanged } from '../auth/firebase'
import { editProblemInThisWindow } from '../utils'
import CookieLaw from 'vue-cookie-law'

export default {
    title () { return `Problème #${this.$route.params.publicID}` },
    name: 'Problem',
    data() {
        return {
            showEdit: false,
            showTools: false,
            pbText: null,
            localData: {},
            isModified: false,
            problemQuery: Array,
            problem: null,
            withPIC: false,
            picURL: null,
            user: null,

            cookieAccepted: null
        }
    },
    components: {
        CookieLaw
    },
    async created() {
        this.cookieAccepted = localStorage.getItem('pel:accepted')
        this.user = await onAuthStateChanged(this.db)
    },
    mounted() {
        this.publicID = this.$route.params.publicID
    },
    computed: {
        isEditor() {
        let isEditor = false
        if(this.user) { isEditor = this.user.isEditor }
        return isEditor 
        }
    },
    firestore() {
        const parsedId = parseInt(this.$route.params.publicID);
        return {
            problemQuery: this.db.collection('problems').where('publicID', '==', parsedId)
        }
    },
    watch: {
        pbText(newPbText) {
            if(newPbText != this.originalText && this.cookieAccepted) {
                this.isModified = true
                this.localData[this.publicID] = {
                    pbText: newPbText,
                    isModified: true
                }
                const parsed = JSON.stringify(this.localData);
                localStorage.setItem('pel', parsed);
                }
        },
        showEdit(value) {
            if(value) {
                this.$nextTick(() => this.$refs.edit.focus())
            }
            this.$refs.tooltipEdit.$emit('close')
        },
        showTools() {
            this.$refs.tooltipTools.$emit('close')
            this.showEdit = false
        },
        async problemQuery() {
            console.log('watch')
            if(this.problemQuery.length == 1) {

                this.problem = this.problemQuery[0]
                this.pbText = this.problem.text
                this.originalText = this.problem.text

                if(this.problem.picNameFile) {
                    this.withPIC = true
                    this.picURL = await this.storageRef.child(this.problem.picNameFile).getDownloadURL()
                }

                if (localStorage.getItem('pel') && this.cookieAccepted) {
                    try {
                        this.localData = JSON.parse(localStorage.getItem('pel'));
                        if(this.localData[this.$route.params.publicID].isModified) {
                            this.pbText = this.localData[this.$route.params.publicID].pbText
                            this.isModified = true
                        }
                    } catch(e) {
                        localStorage.removeItem('pel');
                    }
                }
            }
        }
    },
    methods: {
        reset: function() {
            this.localData[this.publicID] = {
                pbText: this.originalText,
                isModified: false
            }
            const parsed = JSON.stringify(this.localData)
            localStorage.setItem('pel', parsed)
            this.isModified = false
            this.pbText = this.originalText
            this.showEdit = false
        },
        editProblemInThisWindow: editProblemInThisWindow,
        copy() {
            this.$refs.copyText.select()
            document.execCommand('copy')
            this.$refs.tooltipCopy.$emit('close')
            this.$bvModal.show('done')
            setTimeout(() => { this.$bvModal.hide('done') }, 1000);
        },
        thankYouMethod() {
            this.cookieAccepted = localStorage.getItem('pel:accepted')
        }
    }
}
</script>

<style scoped>
    pre {
        font-family:    -apple-system, BlinkMacSystemFont, "Segoe UI", Android Roboto, 
                        "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", 
                        sans-serif, "Apple Color Emoji", "Segoe UI Emoji", 
                        "Segoe UI Symbol", "Noto Color Emoji";
        font-size: xx-large;
        white-space: pre-wrap;  
    }
    img {
        margin: 32px 0 0 0;
        max-height: 20vw;
    }
    .tools {
        position: fixed;
        right: 0!important;
        top: 0!important;
        margin: 8px 8px 0 0;
    }
    .tools button {
        margin: 0px 2px 0px 2px;
        box-shadow: 0 1px 3px black;
    }
    .edit {
        resize: none;
        border: solid 2px;
        border-color: #198754;
        height: calc(50vh);
        width: 100%;
        text-align: center;
        outline: none;
        white-space: pre-wrap;
        font-size: xx-large;
        overflow:hidden;
        padding: 16px 16px 16px 16px;
        margin: 16px 16px 16px 16px;
    }
    .container {
        width: 100%;
        margin: 64px auto;
    }
    .copyText {
        resize: none;
        outline: none;
        white-space: pre-wrap;
        font-size: 0px;
        overflow:hidden;
        border: solid 2px;
        border-color: white;
        color: white
    }
    iframe {
        height: calc(100vh);
    }
</style>